import {
  FavoriteProject,
  TCarbonProjectData,
  RecommendationPagination,
  TRecommendedProject,
  TRecommendedProjectData,
  TRecommendationProjectType,
  RecommendationProjectTypeEnum,
} from '../../types';
import { createEntity, LoadableEntityState } from '../lib/';

export type ProjectRecord<V = string> = Record<string, V>;

export interface ProjectsState {
  recommended: LoadableEntityState<{
    items: Array<TRecommendedProject>;
    total: {
      all: number;
      carbon_projects: number;
      recommendations: number;
      searched: number;
      saved: number;
    };
    pagination: { total: number };
  }>;
  carbon: LoadableEntityState<{
    items: Array<TCarbonProjectData>;
    total: {
      all: number;
      carbon_projects: number;
      recommendations: number;
      searched: number;
      saved: number;
    };
  }>;
  forestation: LoadableEntityState<{ items: Array<any>; total?: number }>;
  favorite: LoadableEntityState<{
    items: Array<FavoriteProject>;
    pagination: { total: number };
  }>;

  selected: 'recommendation' | 'current' | 'saved';
  // TODO: move it to filters
  search: { level: number; id: string; name: string } | null;

  searchByNaming: string;

  filterValues: LoadableEntityState<{
    methodologies: Array<string>;
    types: Array<{ id: number; name: string }>;
    max_estimated_annual_emission_reduction: number;
  }>;

  filters: Partial<{
    methodology: Array<string>;
    type_id: Array<string>;
    start_date?: string;
    end_date?: string;
    min_estimated_annual_emission_reduction: number;
    max_estimated_annual_emission_reduction: number;
    locations: any;
  }>;

  pagination: { page: number; perPage: number };

  viewMode: 'list' | 'grid';

  selectedRecommendedProject?: TRecommendedProjectData;
  selectedRecommendationType?: TRecommendationProjectType;
  mangroveViewMode: 'districts' | 'aggregations';
  // all carbon projects
  allCarbonProjects: Array<TCarbonProjectData>;
  // current data layer type (recommended project)
  currentDataLayerType: string;
  currentSkippedItems: number;
  currentGeoRasterData: {
    data: any;
    isLoading: boolean;
  };
  recommendationPagination: RecommendationPagination;
}

export const projectsInitialState: ProjectsState = {
  recommended: createEntity({
    items: [],
    total: { all: 0, carbon_projects: 0, recommendations: 0, searched: 0, saved: 0 },
    pagination: { total: 0 },
    aggregatedPagination: {
      total: 0,
      aggregated: 0,
      district: 0,
      skipped: 0,
      finishAggregated: false,
    },
  }),
  forestation: createEntity({ items: [], total: 0 }),
  carbon: createEntity({
    items: [],
    pagination: { total: 0 },
    total: { all: 0, carbon_projects: 0, recommendations: 0, searched: 0, saved: 0 },
  }),
  favorite: createEntity({ items: [], pagination: { total: 0 } }),
  search: null,
  searchByNaming: '',
  selected: 'current',

  filterValues: createEntity({
    methodologies: [],
    types: [],
    min_estimated_annual_emission_reduction: 0,
    max_estimated_annual_emission_reduction: 999999999,
  }),

  filters: {
    methodology: undefined,
    type_id: undefined,
    min_estimated_annual_emission_reduction: 0,
    max_estimated_annual_emission_reduction: 0,
    start_date: undefined,
    end_date: undefined,
    locations: {},
  },

  pagination: { page: 1, perPage: 15 },

  viewMode: 'list',
  selectedRecommendedProject: undefined,
  selectedRecommendationType: RecommendationProjectTypeEnum.Mangroves,
  mangroveViewMode: 'districts',
  allCarbonProjects: [],
  currentDataLayerType: 'lulc',
  currentSkippedItems: 0,
  currentGeoRasterData: {
    data: null,
    isLoading: false,
  },
  recommendationPagination: {
    aggregatedFinish: false,
    currentPageNumber: 1,
    skippedDistrict: 0,
    totalAggregated: 0,
    totalDistrict: 0,
    totalItems: 0,
  },
};
